<template>
    <section class="memberQualification">
        <div :style="`z-index: 255; position: fixed; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
                :dismissible="notif.dismissible"
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiAccountCheck }}
            </v-icon>
            <span>Member Qualification</span>
        </h1>

        <v-card
            v-if="!showHistory"
            class="docInfoBody"
            elevation="10"
            style="margin: 2% auto 0 auto;"
        >
            <v-row style="height: 70px;">
                <v-col
                    cols="6"
                    style="height: 70px; padding-top: 25px;"
                >
                    <v-autocomplete
                        v-model="selectedAccount"
                        :disabled="loading"
                        hide-details
                        dense
                        :items="items"
                        item-text="nameAndCode"
                        label="Account Name"
                        return-object
                        clearable
                        color="teal"
                        @click:clear="generateQualifiedListClear"
                        @change="clearQualifiedList"
                    >
                        <template #selection="data">
                            <v-chip
                                small
                                color="teal"
                                class="white--text"
                                style="font-weight: 700;"
                            >
                                {{ data.item.ACCT_N }}
                            </v-chip> {{ data.item.ACCT_M }}
                        </template>
                        <template #item="data">
                            <v-chip
                                small
                                color="teal"
                                class="white--text"
                                style="font-weight: 700;"
                            >
                                {{ data.item.ACCT_N }}
                            </v-chip> &nbsp;{{ data.item.ACCT_M }}
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col
                    v-if="selectedAccount"
                    cols="3"
                    style="height: 70px; padding-top: 25px;"
                >
                    <v-text-field
                        v-model="search.query"
                        clearable
                        dense
                        placeholder="Search ..."
                        hide-details
                        color="teal darken-1"
                        :disabled="selectedAccount == null || itemsTbl.length < 1 || loading"
                        :append-icon="mdiMagnify"
                        @click:clear="(search.value = null, excelFile = null)"
                        @keydown.enter.prevent="search.value = search.query"
                        @click:append="search.value = search.query"
                    />
                </v-col>
                <v-col
                    cols="3"
                    style="height: 70px;"
                >
                    <v-card style="margin: 0 0 0 3px; padding: 10px; display: inline-block;">
                        <v-tooltip
                            v-if="selectedAccount"
                            top
                        >
                            <template #activator="{ on }">
                                <v-btn
                                    :style="`min-width: 0; width: 10px; padding: 17px 21px; margin-right: ${badgeMarginRight(selected.length)}px`"
                                    color="teal darken-1 white--text"
                                    class="white--text"
                                    :disabled="selected.length < 1 || loading"
                                    v-on="on"
                                    @click="showEndorsementConfirmation"
                                >
                                    <v-badge
                                        v-if="selected.length > 0"
                                        bordered
                                        color="success"
                                    >
                                        <template #badge>
                                            {{ selected.length }}
                                        </template>
                                        <v-icon>{{ mdiFileSign }}</v-icon>
                                    </v-badge>
                                    <v-icon v-else>
                                        {{ mdiFileSign }}
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Generate Endorsement and Confirmation</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    color="teal darken-1 white--text"
                                    :style="`min-width: 0; width: 10px; padding: 17px 21px; margin-left: ${selectedAccount ? '10px' : 0};`"
                                    v-on="on"
                                    @click="showHistory = !showHistory"
                                >
                                    <v-icon>{{ mdiFormatListBulleted }}</v-icon>
                                </v-btn>
                            </template>
                            <span>List of Endorsement and Confirmation</span>
                        </v-tooltip>
                    </v-card>
                </v-col>
            </v-row>
            <v-row style="height: 70px;">
                <v-col
                    cols="3"
                    style="height: 70px; padding-top: 25px;"
                >
                    <v-autocomplete
                        v-model="mode"
                        :disabled="loading || selectedAccount == null"
                        hide-details
                        dense
                        :items="mode_list"
                        label="Mode"
                        color="teal"
                        @change="excelFile = null"
                    />
                </v-col>
                <v-col
                    cols="3"
                    style="height: 70px; padding-top: 25px;"
                >
                    <v-file-input
                        v-model="excelFile"
                        :disabled="mode != 'UPLOAD EXCEL FILE' || selectedAccount == null"
                        hide-details
                        dense
                        label="Attach Excel File"
                        color="teal"
                    />
                </v-col>
                <v-col
                    cols="3"
                    style="height: 70px; padding-top: 25px;"
                >
                    <v-tooltip
                        v-if="selectedAccount"
                        top
                    >
                        <template #activator="{ on }">
                            <v-btn
                                :disabled="loading"
                                color="teal darken-1 white--text"
                                style="padding: 17px 21px; margin-right: 10px;"
                                v-on="on"
                                @click="reloadFunc"
                            >
                                <v-icon>{{ mdiPlaylistCheck }}</v-icon>&nbsp;Generate List
                            </v-btn>
                        </template>
                        <span>Generate List</span>
                    </v-tooltip>
                </v-col>
                <v-col
                    cols="3"
                    style="height: 70px; padding-top: 25px;"
                >
                    <v-tooltip
                        v-if="selectedAccount"
                        top
                    >
                        <template #activator="{ on }">
                            <v-btn
                                :disabled="loading || itemsTbl && itemsTbl.length < 1"
                                color="teal darken-1 white--text"
                                style="padding: 17px 21px; margin-right: 10px;"
                                v-on="on"
                                @click="triggerDownload"
                            >
                                <v-icon>{{ mdiFileExcel }}</v-icon>&nbsp;Export to Excel
                            </v-btn>
                        </template>
                        <span>Export to Excel</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-tabs
                v-model="tab"
                background-color="transparent"
                color="teal darken-1"
            >
                <v-tab
                    v-for="item in tabItems"
                    :key="item"
                    :disabled="selectedAccount == null || generateQualifiedListData == null || loading"
                    style="width: 150px;"
                >
                    <div
                        v-if="!loading && allCount > 0 && generateQualifiedListData && generateQualifiedListData.data"
                    >
                        <v-badge :color="item === 'qualified' ? 'success' : item === 'all' ? 'secondary' : 'error'">
                            {{ item }}<template #badge>
                                {{ item === 'qualified' ? qualifiedCount : item === 'all' ? allCount : disqualifiedCount }}
                            </template>
                        </v-badge>
                    </div>
                    <div v-else>
                        {{ item }}
                    </div>
                </v-tab>
            </v-tabs>
            <MemberQualificationTable
                v-model="selected"
                :items="itemsTbl"
                :loading="loading"
                :disabled="selectedAccount == null"
                :search="search.value"
            />
        </v-card>
        <SignPage
            v-else
            :notif="notif"
            :screen_width="screen_width"
            @handleBackToMain="showHistory = !showHistory"
        />
        <EndorsementConfirmation
            :show="showEndorsement"
            :selected="selected"
            :notif="notif"
            @closeDialog="showEndorsement = false"
        />
    </section>
</template>

<script>
import EndorsementConfirmation from './EndorsementConfirmation/Generate/IndexPage.vue'
import { saveAs } from 'file-saver'
import { mapActions, mapGetters } from 'vuex'
import SignPage from './EndorsementConfirmation/Sign/IndexPage.vue'
import MemberQualificationTable from '../MemberQualificationTable.vue'

import { 
    mdiAccountCheck,
    mdiMagnify,
    mdiFileSign,
    mdiFormatListBulleted,
    mdiPlaylistCheck,
    mdiFileExcel } from '@mdi/js'
import { base64ToBlob } from '../../../../utils/helpers'
export default {
    components: { EndorsementConfirmation, SignPage, MemberQualificationTable },
    data: ()=>({
        mdiAccountCheck,
        mdiMagnify,
        mdiFileSign,
        mdiFormatListBulleted,
        mdiPlaylistCheck,
        mdiFileExcel,
        search: {
            value: null,
            query: null
        },
        showReport: false,
        showHistory: false,
        showEndorsement: false,
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success',
            dismissible: false
        },
        selected: [],
        selectedAccount: null,
        accounts: [],
        tab: null,
        tabItems: ['all', 'qualified', 'disqualified'],
        items: null,
        loading: false,
        screen_width: document.documentElement.clientWidth + 9,
        mode: 'SYSTEM GENERATED',
        mode_list: [
            'SYSTEM GENERATED',
            'UPLOAD EXCEL FILE'
        ],
        excelFile: null

    }),
    computed: {
        ...mapGetters(['acuActiveListData', 'generateQualifiedListData', 'listEndorsementConfirmationData', 'viewAccountClinicsData']),
        itemsTbl() {
            if (this.selectedAccount !== null && this.generateQualifiedListData && this.generateQualifiedListData.data) {
                if (this.tab === 0) {
                    const qualified = this.generateQualifiedListData.data.qualified
                    const disqualified = this.generateQualifiedListData.data.disqualified
                    return [...qualified, ...disqualified]
                } else if (this.tab === 1) {
                    return this.generateQualifiedListData.data.qualified
                } else {
                    return this.generateQualifiedListData.data.disqualified
                }
            } else {
                return []
            }
        },
        allCount() {
            if (this.generateQualifiedListData && this.generateQualifiedListData.data) {
                const qualified = this.generateQualifiedListData.data.qualified.length
                const disqualified = this.generateQualifiedListData.data.disqualified.length
                return qualified + disqualified
            }
            return 0
        },
        qualifiedCount() {
            if (this.generateQualifiedListData && this.generateQualifiedListData.data) {
                return this.generateQualifiedListData.data.qualified.length
            }
            return 0
        },
        disqualifiedCount() {
            if (this.generateQualifiedListData && this.generateQualifiedListData.data) {
                return this.generateQualifiedListData.data.disqualified.length
            }
            return 0
        }
    },
    watch: {
        showHistory(newVal) {
            if (newVal) {
                this.listEndorsementConfirmation()
            }
        },
        'search.query'(newVal) {
            if (newVal === '') {
                this.search.value = null
            }
        },
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        generateQualifiedListData() {
            this.loading = false
        },
        acuActiveListData(newVal) {
            if (newVal && newVal.status === 200) {
                let newArr = []
                for (let i=0; i<newVal.data.length; i++) {
                    newArr.push({ ...newVal.data[i], nameAndCode: `${newVal.data[i].ACCT_N} ${newVal.data[i].ACCT_M}` })
                }
                this.items = newArr
            }
            this.loading = false
            this.tab = 0
        }
    },
    created() {
        // this.getCsrfToken()
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.loading = true
        this.acuActiveList()
    },
    beforeDestroy() {
        this.cancelAcuActiveList()
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
        this.generateQualifiedList({ ACCT_N: null })
    },
    methods: {
        ...mapActions(['acuActiveList', 'getCsrfToken', 'generateQualifiedList', 'viewAccountClinics', 'listEndorsementConfirmation', 'validateMembersFromExcel', 'cancelAcuActiveList']),
        badgeMarginRight(num) {
            if (num && num !== null && num > 0) {
                return String(num).length * 5
            } else {
                return 0
            }
        },
        async showEndorsementConfirmation() {
            this.loading = true
            if (this.selected && this.selected[0]) {
                await this.viewAccountClinics({ ACCT_N: this.selected[0].ACCT_N })
                if (this.viewAccountClinicsData.data.status !== 401) {
                    this.showEndorsement = true
                }
            }
            this.loading = false
        },
        triggerDownload() {
            this.handleFileDownload({ file: this.generateQualifiedListData.data.file, type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }, `${this.selectedAccount.ACCT_M}..xlsx`)
            this.notif.type = 'success'
            this.notif.color = 'success'
            this.notif.timeout = 5000
            this.notif.msg = 'Download Complete'
            this.notif.show = true
            this.show.delete = false
        },
        // Utility function to handle file download
        handleFileDownload(data, fileName) {
            try {
                const blob = base64ToBlob(data.file, data.type)
                console.log('handleFileDownload')
                const url = URL.createObjectURL(blob)
                saveAs(blob, fileName)
                URL.revokeObjectURL(url) // Clean up the URL object
            } catch (err) {
                // console.error('err: ', err)
            }
        },
        reloadFunc() {
            this.generateQualifiedListFunc()
        },
        generateQualifiedListClear() {
            this.selectedAccount = null
            this.clearQualifiedList()
        },
        clearQualifiedList() {
            this.$store.commit('GENERATE_QUALIFIED_LIST', [])
            this.selected = []
        },
        generateQualifiedListFunc() {
            if (this.selectedAccount && this.selectedAccount.ACCT_N) {
                this.loading = true
                if (this.mode === 'SYSTEM GENERATED') this.generateQualifiedList({ ACCT_N: this.selectedAccount.ACCT_N })

                if (this.mode === 'UPLOAD EXCEL FILE') {
                    const formData = new FormData()
                    formData.append('excelFile', this.excelFile)
                    formData.append('ACCT_N', this.selectedAccount.ACCT_N)
                    this.validateMembersFromExcel(formData)
                }
            }
            this.selected = []
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.no-padding-header {
    padding: 0 !important;
}
.memberQualification h1 {
    position: relative;
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.memberQualification .docInfoBody {
    margin-top: 5%;
    padding: 3%;
}
.memberQualificationTbl > div > table > thead > tr > th {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    z-index: 2; /* Ensure the second column has a lower z-index than the first one */
    background: white;
    top: 0;
}
.memberQualificationTbl > div > table > tbody > tr > td:nth-child(1) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    padding: 0;
    left: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.memberQualificationTbl > div > table > tbody > tr > td:nth-child(2) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    padding: 0;
    left: 93px;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.memberQualificationTbl > div > table > thead > tr > th:nth-child(1) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    left: 0;
    z-index: 5; /* Ensure the first column has a higher z-index */
    background: white;
}
.memberQualificationTbl > div > table > thead > tr > th:nth-child(2) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    left: 93px;
    z-index: 5; /* Ensure the first column has a higher z-index */
    background: white;
}
.memberQualificationTbl .v-data-table__wrapper {
    max-height: 70vh; /* Adjust the height according to your needs */
    overflow-y: auto; /* Enable vertical scrolling */
}
</style>
